// src/Navbar.js
import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

import { isManagementSession, clearManagementSession, clearFrontendSession } from '../utils/managementAuth';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = sessionStorage.getItem("authToken");
  const adminSession = isManagementSession();

  let user = {};
  try {
    user = JSON.parse(sessionStorage.getItem("user")) || {};
  } catch (e) {
    console.error("Failed to parse user data", e);
  }

  const handleLogout = () => {
    clearFrontendSession();
    navigate('/home');
    window.location.reload();
  };

  const handleAdminLogout = () => {
    clearManagementSession();
    navigate('/management');
    window.location.reload();
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container">
        {/* Brand/Logo */}
        <Link className="navbar-brand fw-bold" to={adminSession ? "/management/dashboard" : (token ? "/" : "/home")}>
          <i className="las la-shield-alt me-2 text-primary"></i>
          SECURE360
        </Link>

        {/* Mobile toggle button */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navbar items */}
        <div className="collapse navbar-collapse" id="navbarNav">
          {/* Left side menu items */}
          <ul className="navbar-nav me-auto">
            {token ? (
              // Logged in user menu items
              <>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
                    to="/"
                  >
                    <i className="las la-tachometer-alt me-1"></i>
                    Dashboard
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === '/scans' ? 'active' : ''}`}
                    to="/scans"
                  >
                    <i className="las la-search me-1"></i>
                    Scans
                  </Link>
                </li>

              </>
            ) : adminSession ? (
              // Admin menu items
              <>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === '/management/dashboard' ? 'active' : ''}`}
                    to="/management/dashboard"
                  >
                    <i className="las la-user-shield me-1"></i>
                    Dashboard
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === '/management/users' ? 'active' : ''}`}
                    to="/management/users"
                  >
                    <i className="las la-users me-1"></i>
                    Users
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/management/settings"
                  >
                    <i className="las la-cog me-1"></i>
                    Settings
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === '/management/findings' ? 'active' : ''}`}
                    to="/management/findings"
                  >
                    <i className="las la-exclamation-triangle me-1"></i>
                    Findings
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === '/management/discovered-assets' ? 'active' : ''}`}
                    to="/management/discovered-assets"
                  >
                    <i className="las la-radar me-1"></i>
                    Discovered
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/management/logs"
                  >
                    <i className="las la-clipboard-list me-1"></i>
                    Logs
                  </Link>
                </li>
              </>
            ) : (
              // Public menu items
              <>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === '/home' ? 'active' : ''}`}
                    to="/home"
                  >
                    <i className="las la-home me-1"></i>
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === '/plans' ? 'active' : ''}`}
                    to="/plans"
                  >
                    <i className="las la-tags me-1"></i>
                    Plans
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === '/demo-check' ? 'active' : ''}`}
                    to="/demo-check"
                  >
                    <i className="las la-play-circle me-1"></i>
                    Quick Demo
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === '/roadmap' ? 'active' : ''}`}
                    to="/roadmap"
                  >
                    <i className="las la-map me-1"></i>
                    Roadmap
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === '/documentation' ? 'active' : ''}`}
                    to="/documentation"
                  >
                    <i className="las la-question-circle me-1"></i>
                    Help
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}
                    to="/about"
                  >
                    <i className="las la-info-circle me-1"></i>
                    About Us
                  </Link>
                </li>
              </>
            )}
          </ul>

          {/* Right side menu items */}
          <ul className="navbar-nav">
            {token ? (
              // Logged in user menu
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#!"
                  role="button"
                  data-bs-toggle="dropdown"
                  style={{ cursor: 'pointer' }}
                >
                  <i className="las la-user me-1"></i>
                  {user.username || 'User'}
                </a>
                <ul className="dropdown-menu">
                  <li><span className="dropdown-item-text small text-muted">Signed in as {user.email}</span></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li>
                    <Link className="dropdown-item" to="/settings">
                      <i className="las la-cog me-2"></i>
                      Profile Settings
                    </Link>
                  </li>
                  <li>
                    <button className="dropdown-item" onClick={handleLogout}>
                      <i className="las la-sign-out-alt me-2"></i>
                      Logout
                    </button>
                  </li>
                </ul>
              </li>
            ) : adminSession ? (
              // Admin user menu
              <div className="d-flex align-items-center">
                <Link to="/home" className="btn btn-outline-light btn-sm me-2"><i className="las la-globe me-1"></i>Main Site</Link>
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle text-warning"
                    href="#!"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
                    <i className="las la-user-shield me-1"></i>
                    Admin
                  </a>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li><span className="dropdown-item-text small text-muted">Superadmin Mode</span></li>
                    <li><hr className="dropdown-divider" /></li>
                    <li>
                      <Link className="dropdown-item" to="/management/dashboard">
                        <i className="las la-tachometer-alt me-2"></i>
                        Dashboard
                      </Link>
                    </li>
                    <li>
                      <button className="dropdown-item text-danger" onClick={handleAdminLogout}>
                        <i className="las la-sign-out-alt me-2"></i>
                        Admin Logout
                      </button>
                    </li>
                  </ul>
                </li>
              </div>
            ) : (
              // Public auth buttons
              <>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === '/login' ? 'active' : ''}`}
                    to="/login"
                  >
                    <i className="las la-sign-in-alt me-1"></i>
                    Login
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === '/register' ? 'active' : ''}`}
                    to="/register"
                  >
                    <i className="las la-user-plus me-1"></i>
                    Register
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>

  );
};

export default Navbar;